import { filter } from 'rxjs/operators';
import { CryptoJsService } from './../../../services/crypto-js.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { TokenService } from 'src/app/services/common/token.service';
import { MessageService } from 'primeng/api';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';

@Component({
  selector: 'app-department-consent-form',
  templateUrl: './department-consent-form.component.html',
  styleUrls: ['./department-consent-form.component.scss'],
})
export class DepartmentConsentFormComponent implements OnInit {
  items: any[];
  selectedStatus: any;
  remarks: String;
  appId: String;
  userID: any;
  isActionSectionEnabled: boolean = false;

  constructor(
    private deptDashBoardService: DepartmentDashboardService, 
    private messageService: MessageService, 
    private route: ActivatedRoute, 
    private router: Router, 
    private tokenService: TokenService, 
    private cryptoJsService: CryptoJsService, 
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService) { }

  ngOnInit(): void {
    this.appId = this.route.snapshot.paramMap.get('appId');
    this.route.queryParams
      .subscribe(params => {
        if (params?.statusCode == this.cryptoJsService.Encrypt('C') || params?.statusCode == this.cryptoJsService.Encrypt('P')) {
          this.isActionSectionEnabled = true;
        } else {
          this.isActionSectionEnabled = false;
        }
      }
      );
    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;


    let actionId = 2; // Do not Change, it is fixed for Farmer Application Verifications
    this.loader.start();
    this.deptDashBoardService
      .GetStatusMaster(JSON.parse(payload)?.sub, actionId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.activityRecordService.activityRecord(this.userID, 'View Application For Approval', this.appId, new Date(), 'Success');
          this.items = data.$values;
        },
        error: (err) => {
          this.loader.close();
          this.activityRecordService.activityRecord(this.userID, 'View Application For Approval', this.appId, new Date(), err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Status Master cant be Loaded',
          });
        },
      });
  }

  handleClick() {
    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.loader.start();
    this.deptDashBoardService
      .InsertFarmerApplicationApprovalRemarks(
        this.appId,
        JSON.parse(payload)?.sub,
        this.remarks,
        this.selectedStatus.flag
      )
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          let resp = JSON.stringify(data);
          this.activityRecordService.activityRecord(this.userID, 'Submit Approval', this.appId, new Date(), data);
          if(resp.startsWith('"S')){
            this.messageService.add({
              severity: 'success',
              summary: 'Status',
              detail: resp,
            });
          }
          else{
            this.messageService.add({
              severity: 'error',
              summary: 'Status',
              detail: resp,
            });
          }
          
          if (data == 'S:Successfully Submitted' || 'S:Successfully Updated') {

            let componentName = window.sessionStorage.getItem('currentComponent');

            if (sessionStorage.getItem('userRole') == 'DD Associate') {
              // let applications = JSON.parse(window.sessionStorage.getItem("FarmerApplicationForApproval"));
              let applications = JSON.parse(window.sessionStorage.getItem(componentName));
              applications.filter(application => {
                return application.appID === this.appId
              }).forEach(element => {
                // element.Status_Ar = this.selectedStatus.flag == 'A' ? 'A' : 'C',
                  element.Status_Ar = 'C',
                  element.status = this.selectedStatus.flag == 'A' ? 'Approved' : (this.selectedStatus.flag == 'RP') ? 'Return Process' : (this.selectedStatus.flag == 'R') ? 'Rejected' : 'Marked Return',
                  element.NextLevelID = 'DDMICADA',
                  element.remarks = this.remarks

              });
              // sessionStorage.setItem('FarmerApplicationForApproval', JSON.stringify(applications));
              sessionStorage.setItem(componentName, JSON.stringify(applications));

            } else if (sessionStorage.getItem('userRole') == 'DDMICADA') {

              // let applications = JSON.parse(window.sessionStorage.getItem("FarmerApplicationForApproval"));
              let applications = JSON.parse(window.sessionStorage.getItem(componentName));
              applications.filter(application => {
                return application.appID === this.appId
              }).forEach(element => {

                let nextLevelId;
                if(this.selectedStatus.flag == 'A'){
                  nextLevelId = 'DMICADA';
                }else if(this.selectedStatus.flag == 'RP'){
                  nextLevelId = 'Farmer'
                }else if(this.selectedStatus.flag == 'R'){
                  nextLevelId = 'N/A'
                }

                // element.Status_Ar = this.selectedStatus.flag == 'A' ? 'A' : 'C',
                element.Status_Ar = 'C',
                  element.status = this.selectedStatus.flag == 'A' ? 'Approved' : (this.selectedStatus.flag == 'RP') ? 'Return Process' : (this.selectedStatus.flag == 'R') ? 'Rejected' : 'Marked Return',
                  element.NextLevelID = nextLevelId,
                  element.remarks = this.remarks

              });
              // sessionStorage.setItem('FarmerApplicationForApproval', JSON.stringify(applications));
              sessionStorage.setItem(componentName, JSON.stringify(applications));
            }
            else if (sessionStorage.getItem('userRole') == 'DMICADA') {

              // let applications = JSON.parse(window.sessionStorage.getItem("FarmerApplicationForApproval"));
              let applications = JSON.parse(window.sessionStorage.getItem(componentName));
              applications.filter(application => {
                return application.appID === this.appId
              }).forEach(element => {

                let nextLevelId;
                if(this.selectedStatus.flag == 'A'){
                  nextLevelId = 'Vendor';
                }else if(this.selectedStatus.flag == 'RP'){
                  nextLevelId = 'Farmer'
                }else if(this.selectedStatus.flag == 'R'){
                  nextLevelId = 'N/A'
                }

                // element.Status_Ar = this.selectedStatus.flag == 'A' ? 'A' : 'C',
                element.Status_Ar = 'C',
                  element.status = this.selectedStatus.flag == 'A' ? 'Approved' : (this.selectedStatus.flag == 'RP') ? 'Return Process' : (this.selectedStatus.flag == 'R') ? 'Rejected' : 'Marked Return',
                  element.NextLevelID = nextLevelId,
                  element.remarks = this.remarks

              });
              // sessionStorage.setItem('FarmerApplicationForApproval', JSON.stringify(applications));
              sessionStorage.setItem(componentName, JSON.stringify(applications));
            }
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Farmer Application Processed Successfully.' });

            if(componentName == 'FarmerApplicationForApprovalPending'){
              this.router.navigate(['/department/farmer-applications/pending']);
            }
            else if(componentName == 'FarmerApplicationForApprovalCurrent'){
              this.router.navigate(['/department/farmer-applications/current']);
            }
          }
          // this.router.navigate(['department']);
        },
        error: (err) => {
          this.loader.close();
          this.activityRecordService.activityRecord(this.userID, 'Submit Approval', '', new Date(), err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
      // this.router.navigate(['/department/farmer-applications']);
  }
}
